<div
  class="payee-dropzone-wrapper"
  dropzone
  [class.hovering]="isHovering"
  (hovered)="toggleHover($event)"
  (dropped)="filesChosen($event)"
  (click)="uploadClick(upload)"
>
  <div class="content">
    <div>
      <payee-icon
        name="upload-cloud"
        [width]="'40px'"
        [height]="'40px'"
      ></payee-icon>
    </div>
    @if (title) {
      <div class="title">
        {{ title }}
      </div>
    }
    @if (description) {
      <div class="description">
        {{ description }}
      </div>
    }
  </div>
  <input
    #upload
    hidden
    type="file"
    [multiple]="multiple"
    [accept]="accept"
    (change)="uploadChange($event)"
  />
</div>
